export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_05.b19ddb13.jpg";